// src/context/DashboardUIContext.js
import React, { createContext, useState, useContext, useMemo } from 'react';

const DashboardUIContext = createContext();

export const useDashboardUI = () => {
    return useContext(DashboardUIContext);
};

export const DashboardUIProvider = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isDashboardPage, setIsDashboardPage] = useState(false);

    const toggleSidebar = () => setSidebarOpen(prev => !prev);
    const closeSidebar = () => setSidebarOpen(false);

    const value = useMemo(() => ({
        sidebarOpen,
        setSidebarOpen,
        toggleSidebar,
        closeSidebar,
        isDashboardPage,
        setIsDashboardPage
    }), [sidebarOpen, isDashboardPage]);

    return (
        <DashboardUIContext.Provider value={value}>
            {children}
        </DashboardUIContext.Provider>
    );
};